import { useEffect, useState } from 'react';

type Props = {
  size?: number;
  animated?: boolean;
  paused?: boolean;
  className?: string;
};

// 5-cell Conway glider walking diagonally inside a black disc on blue field.
// The glider goes through its 4-frame cycle (period 4, moves SE by (1,1) every 4 steps).
const GLIDER_FRAMES: Array<Array<[number, number]>> = [
  [[1, 0], [2, 1], [0, 2], [1, 2], [2, 2]],
  [[0, 1], [2, 1], [1, 2], [2, 2], [1, 3]],
  [[2, 1], [0, 2], [2, 2], [1, 3], [2, 3]],
  [[1, 1], [2, 2], [3, 2], [1, 3], [2, 3]],
];

export function GliderLogo({ size = 32, animated = false, paused = false, className }: Props) {
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    if (!animated || paused) return;
    const id = setInterval(() => setFrame((f) => (f + 1) % 4), 1500);
    return () => clearInterval(id);
  }, [animated, paused]);

  const cellSize = 10;
  const grid = GLIDER_FRAMES[frame];
  // Shift glider down-right based on frame to "walk"
  const driftX = frame >= 2 ? 1 : 0;
  const driftY = frame >= 2 ? 1 : 0;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="AUTOMATON glider logo"
    >
      <rect width="100" height="100" fill="#1E6FFF" />
      <circle cx="50" cy="50" r="40" fill="#000000" />
      <g transform={`translate(${28 + driftX * 4}, ${22 + driftY * 4})`}>
        {grid.map(([x, y], i) => (
          <rect
            key={i}
            x={x * cellSize}
            y={y * cellSize}
            width={cellSize - 1}
            height={cellSize - 1}
            fill="#1E6FFF"
          />
        ))}
      </g>
    </svg>
  );
}
